export const OPERATOR_IN = 'in';
export const OPERATOR_EQ = 'eq';
